import React, { useRef } from "react";
import "./GemstoneGalloreSection.css";
import video2 from "../Images/video2.mp4";
import { Link } from "react-router-dom";

const gemstoneProducts = [
  {
    name: "Spinelle Charlotte Diamond Ring",
    oldPrice: "₹29,999",
    price: "₹24,999",
    img: "https://spinellejewelry.com/cdn/shop/files/solitaire-wedding-ring-3d-model-obj-fbx-stl-3dm_2.jpg?v=1742970101&width=450",
  },
  {
    name: "Spinelle Ana Diamond Pendant",
    oldPrice: "₹22,000",
    price: "₹18,499",
    img: "https://spinellejewelry.com/cdn/shop/files/women-pendant-3dm-stl-obj-fbx-renders-details-3d-model-f1e5a34f84.jpg?v=1742283038&width=450",
  },
  {
    name: "Sapphire Elegance Earrings",
    oldPrice: "₹34,999",
    price: "₹29,999",
    img: "https://spinellejewelry.com/cdn/shop/files/women-stud-earrings-3dm-stl-obj-fbx-renders-details-3d-model-c6320212c1.jpg?v=1742879965&width=450",
  },
  {
    name: "Amethyst Spark Necklace",
    oldPrice: "₹25,499",
    price: "₹21,999",
    img: "https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-530f37a828.jpg?v=1716624902&width=450",
  },
  {
    name: "Spinelle Charlotte Diamond Ring",
    oldPrice: "₹29,999",
    price: "₹24,999",
    img: "https://spinellejewelry.com/cdn/shop/files/solitaire-wedding-ring-3d-model-obj-fbx-stl-3dm_2.jpg?v=1742970101&width=450",
  },
  {
    name: "Spinelle Ana Diamond Pendant",
    oldPrice: "₹22,000",
    price: "₹18,499",
    img: "https://spinellejewelry.com/cdn/shop/files/women-pendant-3dm-stl-obj-fbx-renders-details-3d-model-f1e5a34f84.jpg?v=1742283038&width=450",
  },
  {
    name: "Sapphire Elegance Earrings",
    oldPrice: "₹34,999",
    price: "₹29,999",
    img: "https://spinellejewelry.com/cdn/shop/files/women-stud-earrings-3dm-stl-obj-fbx-renders-details-3d-model-c6320212c1.jpg?v=1742879965&width=450",
  },
  {
    name: "Amethyst Spark Necklace",
    oldPrice: "₹25,499",
    price: "₹21,999",
    img: "https://spinellejewelry.com/cdn/shop/files/women-necklace-pendant-3dm-stl-obj-fbx-renders-details-3d-model-530f37a828.jpg?v=1716624902&width=450",
  },
 
];

const GemstoneGalloreSection = () => {
  const carouselRef = useRef(null);

  const scrollLeft = () => {
    carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <section className="gemstone-section">
      <div className="gemstone-banner">
        <video
          src={video2}
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="overlay-text">
          <h2>Gemstone Gallore</h2>
          <p>Explore the Rich Hues and Unique Charms</p>
          <button className="shop-now-btn">Shop 190+ Designs</button>
        </div>
      </div>

      <div className="gemstone-carousel-wrapper">
        
        <div className="carousel" ref={carouselRef}>
          {gemstoneProducts.map((item, i) => (
            <div className="product-card" key={i}>
              <img src={item.img} alt={item.name} />
              <div className="product-price">{item.price} <span>{item.oldPrice}</span></div>
              <div className="product-name">{item.name}</div>
            </div>
          ))}
        </div>

        <button className="carousel-btn left" onClick={scrollLeft}>❮</button>
        <button className="carousel-btn right" onClick={scrollRight}>❯</button>
        <button className="view-full-btn" ><Link to="/products" style={{textDecoration:'none', color:'white'}}>View Full Collection </Link></button>
      </div>
    </section>
  );
};

export default GemstoneGalloreSection;
